import React, { useEffect, useRef } from 'react';
import Hero from './Hero';
import About from './About';
import Education from './Education';
import Experience from './Experience';
import Certificates from './Certificates';
import Projects from './Projects';
import TechStack from './TechStack';
import Contact from './Contact';
import './Portfolio.css';
import Testimonials from './Testimonials';

const Portfolio = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -100px 0px',
      }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  return (
    <div className="portfolio">
      <div ref={addToRefs}>
        <Hero />
      </div>
      <div ref={addToRefs}>
        <About />
      </div>
      <div ref={addToRefs}>
        <Education />
      </div>
      <div ref={addToRefs}>
        <Experience />
      </div>
      <div ref={addToRefs}>
        <Certificates />
      </div>
      <div ref={addToRefs}>
        <Projects />
      </div>
      <div ref={addToRefs}>
        <Testimonials />
      </div>
      <div ref={addToRefs}>
        <Contact />
      </div>
    </div>
  );
};

export default Portfolio;